import { render, staticRenderFns } from "./InvoiceRecipientModal.vue?vue&type=template&id=050d4590&scoped=true&"
import script from "./InvoiceRecipientModal.vue?vue&type=script&lang=js&"
export * from "./InvoiceRecipientModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050d4590",
  null
  
)

export default component.exports